export default __webpack_public_path__ + "static/stanleyknifemark-eec769f98330d09f2a3797c5f18d94db.png";